import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-truncated-text',
    imports: [ButtonModule],
    templateUrl: './truncated-text.component.html',
    styleUrl: './truncated-text.component.scss'
})
export class TruncatedTextComponent {
  @Input() text:string;
  @Input() truncateHeight:number|undefined
  @ViewChild('textRef') textRef?: ElementRef<HTMLDivElement>;
  isTruncated:boolean = false;
  isShown:boolean = false;
  initialHeight:number; 

  constructor(private cdRef: ChangeDetectorRef) {}


  ngAfterViewInit() {
    
    if (!this.truncateHeight) {
      return;
    }
    if (this.textRef) {
    
      this.initialHeight = this.textRef.nativeElement.offsetHeight;
      
      if (this.truncateHeight <= this.initialHeight) {
        this.isTruncated = true;

        // Trigger second change detection cycle
        this.cdRef.detectChanges();
      }  
    }

      
    
  }

  toggleText() {
    this.isShown = !this.isShown;
  }
} 
